var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Skyflow from 'skyflow-js';
import useCollectListeners from '../../hooks/CollectListner';
import { ELEMENT_CREATED } from '../../utils/constants';
import { SKYFLOW_ERROR_CODE } from '../../utils/errors';
import { v4 as uuid } from 'uuid';
import useUpdateElement from '../../hooks/UpdateElement';
const ExpirationDateElement = (_a) => {
    var props = __rest(_a, []);
    const uniqueDivId = uuid();
    const [element, setElement] = React.useState(null);
    React.useEffect(() => {
        try {
            const newElement = props === null || props === void 0 ? void 0 : props.container.create(Object.assign(Object.assign({ table: props.table, column: props.column }, props.classes), { placeholder: props.placeholder || '', label: props.label || '', type: Skyflow.ElementType.EXPIRATION_DATE, validations: props.validations || [] }), Object.assign({}, props.options));
            setElement(newElement);
            if ((props === null || props === void 0 ? void 0 : props.container.type) === Skyflow.ContainerType.COLLECT) {
                const collectElement = newElement;
                collectElement.mount(props.id ? `#${props.id}` : `#EXPIRATION_DATE-id-${uniqueDivId}`);
            }
            else if ((props === null || props === void 0 ? void 0 : props.container.type) === Skyflow.ContainerType.COMPOSABLE) {
                if (!props.eventEmitter)
                    throw new Error(SKYFLOW_ERROR_CODE.COMPOSABLE_COMPONENT_NOT_PROVIDED.description);
                props.eventEmitter._emit(ELEMENT_CREATED, { id: 'EXPIRATION DATE' });
            }
            useCollectListeners(props, newElement);
        }
        catch (e) {
            console.error(e);
        }
    }, []);
    useUpdateElement(props, element);
    return ((props === null || props === void 0 ? void 0 : props.container.type) === Skyflow.ContainerType.COLLECT
        ? (React.createElement("div", { id: props.id ? props.id : `EXPIRATION_DATE-id-${uniqueDivId}` }))
        : (React.createElement(React.Fragment, null)));
};
export default React.memo(ExpirationDateElement);
//# sourceMappingURL=index.js.map